
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.11.0
 * Query Engine version: efd2449663b3d73d637ea1fd226bafbcf45b3102
 */
Prisma.prismaVersion = {
  client: "5.11.0",
  engine: "efd2449663b3d73d637ea1fd226bafbcf45b3102"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ReplicacheClientGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  clientVersion: 'clientVersion',
  cvrVersion: 'cvrVersion'
};

exports.Prisma.RelationLoadStrategy = {
  query: 'query',
  join: 'join'
};

exports.Prisma.ReplicacheClientScalarFieldEnum = {
  replicacheClientId: 'replicacheClientId',
  lastMutationId: 'lastMutationId'
};

exports.Prisma.NewReplicacheClientScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastMutationId: 'lastMutationId',
  lastModifiedClientVersion: 'lastModifiedClientVersion',
  replicacheClientGroupId: 'replicacheClientGroupId'
};

exports.Prisma.PersonalSlackNotificationSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  token: 'token',
  teamId: 'teamId',
  teamName: 'teamName',
  slackUserId: 'slackUserId',
  followUpMessageNotificationsEnabled: 'followUpMessageNotificationsEnabled',
  assignmentChangesNotificationsEnabled: 'assignmentChangesNotificationsEnabled',
  commentCreatedNotificationsEnabled: 'commentCreatedNotificationsEnabled',
  newThreadNotificationsEnabled: 'newThreadNotificationsEnabled',
  commentMentionsNotificationsEnabled: 'commentMentionsNotificationsEnabled',
  unassignedThreadReplyNotificationsEnabled: 'unassignedThreadReplyNotificationsEnabled',
  newEmailCreatedNotificationsEnabled: 'newEmailCreatedNotificationsEnabled',
  membershipId: 'membershipId'
};

exports.Prisma.MembershipScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  role: 'role',
  userId: 'userId',
  workspaceId: 'workspaceId',
  emailSignature: 'emailSignature',
  recallZoomOauthCredentialsId: 'recallZoomOauthCredentialsId',
  recallGoogleCalendarId: 'recallGoogleCalendarId',
  recallOutlookCalendarId: 'recallOutlookCalendarId',
  recallJoinCalendarEvents: 'recallJoinCalendarEvents',
  recallOnlyRecordConfirmedMeetings: 'recallOnlyRecordConfirmedMeetings',
  recallRecordExternalEvents: 'recallRecordExternalEvents'
};

exports.Prisma.WorkspaceInviteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  acceptedAt: 'acceptedAt',
  workspaceId: 'workspaceId',
  state: 'state',
  token: 'token',
  inviteName: 'inviteName',
  inviteEmail: 'inviteEmail',
  invitedById: 'invitedById',
  role: 'role'
};

exports.Prisma.TokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hashedToken: 'hashedToken',
  type: 'type',
  expiresAt: 'expiresAt',
  userId: 'userId',
  workspaceId: 'workspaceId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  role: 'role',
  imageUrl: 'imageUrl',
  name: 'name',
  feedbackEmailsEnabled: 'feedbackEmailsEnabled',
  changelogEmailsEnabled: 'changelogEmailsEnabled',
  upvoteEmailsEnabled: 'upvoteEmailsEnabled',
  unpublishedProjectsEmailsEnabled: 'unpublishedProjectsEmailsEnabled',
  inboxZeroEmailsEnabled: 'inboxZeroEmailsEnabled',
  selectedTeamIds: 'selectedTeamIds',
  newThreadNotificationsEnabled: 'newThreadNotificationsEnabled',
  assignedThreadsReplyReceivedNotificationsEnabled: 'assignedThreadsReplyReceivedNotificationsEnabled',
  unassignedThreadsReplyReceivedNotificationsEnabled: 'unassignedThreadsReplyReceivedNotificationsEnabled',
  commentMentionsNotificationsEnabled: 'commentMentionsNotificationsEnabled',
  assignmentChangesNotificationsEnabled: 'assignmentChangesNotificationsEnabled',
  googleToken: 'googleToken',
  onboarded: 'onboarded',
  version: 'version',
  source: 'source'
};

exports.Prisma.EmailSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  postmarkInboundEmailAddress: 'postmarkInboundEmailAddress',
  postmarkServerApiKey: 'postmarkServerApiKey',
  postmarkServerId: 'postmarkServerId',
  postmarkDomainId: 'postmarkDomainId',
  primaryEmail: 'primaryEmail',
  brandedInboundEmailAddress: 'brandedInboundEmailAddress',
  isEnabled: 'isEnabled',
  isForwardingSetup: 'isForwardingSetup',
  txtDnsKey: 'txtDnsKey',
  txtDnsValue: 'txtDnsValue',
  isTxtDnsActive: 'isTxtDnsActive',
  cnameDnsKey: 'cnameDnsKey',
  cnameDnsValue: 'cnameDnsValue',
  isCnameDnsActive: 'isCnameDnsActive',
  workspaceId: 'workspaceId'
};

exports.Prisma.ThreadMessageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isDeleted: 'isDeleted',
  title: 'title',
  text: 'text',
  actorName: 'actorName',
  actorImage: 'actorImage',
  workspaceId: 'workspaceId',
  threadId: 'threadId'
};

exports.Prisma.EmailScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  date: 'date',
  version: 'version',
  isDeleted: 'isDeleted',
  type: 'type',
  subject: 'subject',
  originalRecipient: 'originalRecipient',
  from: 'from',
  to: 'to',
  cc: 'cc',
  bcc: 'bcc',
  attachments: 'attachments',
  textContent: 'textContent',
  htmlContent: 'htmlContent',
  postmarkMessageId: 'postmarkMessageId',
  messageId: 'messageId',
  raw: 'raw',
  uniqueId: 'uniqueId',
  threadId: 'threadId',
  workspaceId: 'workspaceId',
  userId: 'userId'
};

exports.Prisma.AttachmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isDeleted: 'isDeleted',
  url: 'url',
  name: 'name',
  originalName: 'originalName',
  fileType: 'fileType',
  contentType: 'contentType',
  size: 'size',
  emailId: 'emailId',
  workspaceId: 'workspaceId',
  uploaderId: 'uploaderId'
};

exports.Prisma.SlackUserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isDeleted: 'isDeleted',
  slackId: 'slackId',
  username: 'username',
  name: 'name',
  email: 'email',
  imageUrl: 'imageUrl',
  raw: 'raw',
  workspaceId: 'workspaceId'
};

exports.Prisma.SlackMessageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isDeleted: 'isDeleted',
  type: 'type',
  teamId: 'teamId',
  channelId: 'channelId',
  slackId: 'slackId',
  slackUserId: 'slackUserId',
  slackThreadId: 'slackThreadId',
  text: 'text',
  slackLink: 'slackLink',
  attachments: 'attachments',
  html: 'html',
  raw: 'raw',
  workspaceId: 'workspaceId',
  threadId: 'threadId',
  userId: 'userId'
};

exports.Prisma.SnippetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isDeleted: 'isDeleted',
  title: 'title',
  html: 'html',
  emailId: 'emailId',
  workspaceId: 'workspaceId'
};

exports.Prisma.WorkspaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  name: 'name',
  domain: 'domain',
  logoUrl: 'logoUrl',
  selectedTeamIds: 'selectedTeamIds',
  maxResponseTimeHours: 'maxResponseTimeHours',
  onboardingCompanySize: 'onboardingCompanySize',
  onboardingRole: 'onboardingRole',
  onboardingReferralSource: 'onboardingReferralSource',
  onboardingSignupReason: 'onboardingSignupReason',
  isEmailIntegrationEnabled: 'isEmailIntegrationEnabled',
  emailIntegrationAddress: 'emailIntegrationAddress',
  hasBeenSetup: 'hasBeenSetup',
  showOnboardingBanner: 'showOnboardingBanner',
  hasTriedImportAfterSignup: 'hasTriedImportAfterSignup',
  linearToken: 'linearToken',
  linearOrganizationId: 'linearOrganizationId',
  linearTokenRevoked: 'linearTokenRevoked',
  remainingTranscriptSeconds: 'remainingTranscriptSeconds',
  remainingGeneratedThreadTitles: 'remainingGeneratedThreadTitles',
  transcriptProfanityFilter: 'transcriptProfanityFilter',
  transcriptDefaultLanguage: 'transcriptDefaultLanguage',
  transcriptDetectLanguage: 'transcriptDetectLanguage',
  isRecordingChatMessageEnabled: 'isRecordingChatMessageEnabled',
  apiTokenId: 'apiTokenId',
  apiOrigins: 'apiOrigins',
  customDomain: 'customDomain',
  logoLink: 'logoLink',
  projectDocumentationTemplate: 'projectDocumentationTemplate',
  defaultLinearTeamId: 'defaultLinearTeamId',
  addLinksToLinearProjects: 'addLinksToLinearProjects',
  isGoogleAuthRequired: 'isGoogleAuthRequired',
  googleDomain: 'googleDomain',
  usePortalLogoUrl: 'usePortalLogoUrl',
  portalLogoUrl: 'portalLogoUrl',
  isDueDateEnabled: 'isDueDateEnabled',
  isRoadmapsEnabled: 'isRoadmapsEnabled',
  helpCenterPublic: 'helpCenterPublic',
  changelogPublic: 'changelogPublic',
  changelogAutomaticDrafts: 'changelogAutomaticDrafts',
  changelogLink1Description: 'changelogLink1Description',
  changelogLink1Url: 'changelogLink1Url',
  changelogLink2Description: 'changelogLink2Description',
  changelogLink2Url: 'changelogLink2Url',
  domainPublic: 'domainPublic',
  darkMode: 'darkMode',
  backgroundColor: 'backgroundColor',
  darkModeBackgroundColor: 'darkModeBackgroundColor',
  textColor: 'textColor',
  darkModeTextColor: 'darkModeTextColor',
  accentColor: 'accentColor',
  darkModeAccentColor: 'darkModeAccentColor',
  accentTextColor: 'accentTextColor',
  darkModeAccentTextColor: 'darkModeAccentTextColor',
  buttonTextColor: 'buttonTextColor',
  darkModeButtonTextColor: 'darkModeButtonTextColor',
  portalEmbedImageUrl: 'portalEmbedImageUrl',
  stripeCustomerId: 'stripeCustomerId',
  stripeSubscriptionId: 'stripeSubscriptionId',
  stripePriceId: 'stripePriceId',
  stripeCurrentPeriodEnd: 'stripeCurrentPeriodEnd',
  userId: 'userId'
};

exports.Prisma.AllowedEmailDomainScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  domain: 'domain',
  verificationEmail: 'verificationEmail',
  hashedVerificationToken: 'hashedVerificationToken',
  verificationEmailSentAt: 'verificationEmailSentAt',
  isVerified: 'isVerified',
  verifiedAt: 'verifiedAt',
  workspaceId: 'workspaceId'
};

exports.Prisma.IntercomSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  intercomToken: 'intercomToken',
  intercomWorkspaceId: 'intercomWorkspaceId',
  dataHostRegion: 'dataHostRegion',
  workspaceId: 'workspaceId'
};

exports.Prisma.HubspotSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  token: 'token',
  hubspotWorkspaceId: 'hubspotWorkspaceId',
  hubspotRefreshToken: 'hubspotRefreshToken',
  contactPropertyNames: 'contactPropertyNames',
  companyPropertyNames: 'companyPropertyNames',
  workspaceId: 'workspaceId'
};

exports.Prisma.PlainSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  plainApiKey: 'plainApiKey',
  token: 'token',
  webhookId: 'webhookId',
  cardId: 'cardId',
  plainWorkspaceId: 'plainWorkspaceId',
  workspaceId: 'workspaceId'
};

exports.Prisma.RoadmapSettingsScalarFieldEnum = {
  sortOrder: 'sortOrder',
  googleAuth: 'googleAuth',
  googleDomain: 'googleDomain',
  workspaceId: 'workspaceId'
};

exports.Prisma.CustomerPortalSettingsScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isEnabled: 'isEnabled',
  teamRequests: 'teamRequests',
  callRecordings: 'callRecordings',
  linearIssueTitles: 'linearIssueTitles',
  linearIssueDescription: 'linearIssueDescription',
  adjustImportance: 'adjustImportance',
  showInWidget: 'showInWidget',
  allSourcesEnabled: 'allSourcesEnabled',
  workspaceId: 'workspaceId'
};

exports.Prisma.SlackSettingsScalarFieldEnum = {
  botUserId: 'botUserId',
  token: 'token',
  teamId: 'teamId',
  feedbackHubChannelId: 'feedbackHubChannelId',
  feedbackHubBotMessages: 'feedbackHubBotMessages',
  notificationChannelId: 'notificationChannelId',
  pushBotReply: 'pushBotReply',
  pushBotReplyChannel: 'pushBotReplyChannel',
  workspaceId: 'workspaceId'
};

exports.Prisma.SlackConnectSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  token: 'token',
  teamId: 'teamId',
  teamUrl: 'teamUrl',
  botUserId: 'botUserId',
  feedbackHubChannelId: 'feedbackHubChannelId',
  feedbackHubBotMessages: 'feedbackHubBotMessages',
  notificationChannelId: 'notificationChannelId',
  pushBotReply: 'pushBotReply',
  pushBotReplyChannel: 'pushBotReplyChannel',
  workspaceId: 'workspaceId'
};

exports.Prisma.SsoSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workspaceId: 'workspaceId',
  tokenEndpoint: 'tokenEndpoint',
  secret: 'secret',
  isEnabled: 'isEnabled',
  isPortalPrivate: 'isPortalPrivate'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  hashedSessionToken: 'hashedSessionToken',
  antiCSRFToken: 'antiCSRFToken',
  data: 'data',
  publicData: 'publicData',
  userId: 'userId'
};

exports.Prisma.FeedbackScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  showRecordCall: 'showRecordCall',
  lastInboundMessageAt: 'lastInboundMessageAt',
  lastOutboundMessageAt: 'lastOutboundMessageAt',
  lastStateChangeAt: 'lastStateChangeAt',
  text: 'text',
  yDocText: 'yDocText',
  painLevel: 'painLevel',
  state: 'state',
  origin: 'origin',
  title: 'title',
  snoozedUntil: 'snoozedUntil',
  workspaceId: 'workspaceId',
  contactId: 'contactId',
  companyId: 'companyId',
  reporterId: 'reporterId',
  assigneeId: 'assigneeId',
  recordingId: 'recordingId',
  videoId: 'videoId',
  slackChannelId: 'slackChannelId',
  linearAttachmentId: 'linearAttachmentId',
  intercomId: 'intercomId',
  frontId: 'frontId',
  zendeskId: 'zendeskId',
  hubspotId: 'hubspotId',
  plainId: 'plainId',
  productboardId: 'productboardId',
  slackReplyId: 'slackReplyId',
  uniqueId: 'uniqueId'
};

exports.Prisma.CustomerNeedScalarFieldEnum = {
  id: 'id',
  feedbackId: 'feedbackId',
  issueId: 'issueId',
  linearCustomerNeedId: 'linearCustomerNeedId',
  priority: 'priority'
};

exports.Prisma.FeedbackTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isStandardEnabled: 'isStandardEnabled',
  isDynamicEnabled: 'isDynamicEnabled',
  standardText: 'standardText',
  dynamicText: 'dynamicText',
  workspaceId: 'workspaceId'
};

exports.Prisma.CommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  content: 'content',
  feedbackId: 'feedbackId',
  workspaceId: 'workspaceId',
  userId: 'userId'
};

exports.Prisma.IssueScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  dueDate: 'dueDate',
  workspaceId: 'workspaceId',
  completedAt: 'completedAt',
  linearTicketId: 'linearTicketId',
  title: 'title',
  description: 'description',
  descriptionData: 'descriptionData',
  publicDescription: 'publicDescription',
  publicTitle: 'publicTitle',
  team: 'team',
  identifier: 'identifier',
  status: 'status',
  statusColor: 'statusColor',
  statusName: 'statusName',
  priority: 'priority',
  url: 'url',
  projectId: 'projectId',
  sortOrder: 'sortOrder',
  summary: 'summary',
  summaryUpdated: 'summaryUpdated',
  isVisible: 'isVisible',
  kluGuid: 'kluGuid'
};

exports.Prisma.ProjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  completedAt: 'completedAt',
  name: 'name',
  description: 'description',
  publicDescription: 'publicDescription',
  publicTitle: 'publicTitle',
  notes: 'notes',
  isVisible: 'isVisible',
  icon: 'icon',
  startDate: 'startDate',
  startDateResolution: 'startDateResolution',
  targetDate: 'targetDate',
  targetDateResolution: 'targetDateResolution',
  state: 'state',
  sortOrder: 'sortOrder',
  archived: 'archived',
  color: 'color',
  progress: 'progress',
  linearTeamIds: 'linearTeamIds',
  linearTeamNames: 'linearTeamNames',
  url: 'url',
  summary: 'summary',
  summaryUpdated: 'summaryUpdated',
  workspaceId: 'workspaceId',
  linearProjectId: 'linearProjectId',
  kluGuid: 'kluGuid'
};

exports.Prisma.LinearRoadmapScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  name: 'name',
  linearRoadmapId: 'linearRoadmapId',
  sortPosition: 'sortPosition',
  workspaceId: 'workspaceId'
};

exports.Prisma.ContactScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  email: 'email',
  name: 'name',
  imageUrl: 'imageUrl',
  workspaceId: 'workspaceId',
  intercomId: 'intercomId',
  hubspotId: 'hubspotId',
  productboardId: 'productboardId',
  companyId: 'companyId'
};

exports.Prisma.CustomerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  name: 'name',
  size: 'size',
  revenue: 'revenue',
  statusId: 'statusId',
  statusName: 'statusName',
  statusColor: 'statusColor',
  tierId: 'tierId',
  tierName: 'tierName',
  logoUrl: 'logoUrl',
  domains: 'domains',
  workspaceId: 'workspaceId'
};

exports.Prisma.CompanyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  name: 'name',
  domain: 'domain',
  autoAdd: 'autoAdd',
  workspaceId: 'workspaceId',
  intercomId: 'intercomId',
  hubspotId: 'hubspotId',
  productboardId: 'productboardId',
  customerId: 'customerId'
};

exports.Prisma.CompanyMetaScalarFieldEnum = {
  domain: 'domain',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  brandfetchData: 'brandfetchData'
};

exports.Prisma.UpvoteScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  contactId: 'contactId',
  createdAt: 'createdAt',
  isDeleted: 'isDeleted',
  version: 'version',
  workspaceId: 'workspaceId'
};

exports.Prisma.IssueUpvoteScalarFieldEnum = {
  id: 'id',
  issueId: 'issueId',
  contactId: 'contactId',
  createdAt: 'createdAt',
  isDeleted: 'isDeleted',
  version: 'version',
  workspaceId: 'workspaceId'
};

exports.Prisma.SegmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  name: 'name',
  color: 'color',
  type: 'type',
  intercomId: 'intercomId',
  hubspotId: 'hubspotId',
  workspaceId: 'workspaceId'
};

exports.Prisma.ChangelogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  date: 'date',
  published: 'published',
  title: 'title',
  notes: 'notes',
  archived: 'archived',
  imageUrl: 'imageUrl',
  projectId: 'projectId',
  workspaceId: 'workspaceId'
};

exports.Prisma.MeetingRecordingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  status: 'status',
  recordingStartedAt: 'recordingStartedAt',
  hasRecorded: 'hasRecorded',
  fatalError: 'fatalError',
  botId: 'botId',
  calendarEventId: 'calendarEventId',
  meetingUrl: 'meetingUrl',
  userId: 'userId',
  workspaceId: 'workspaceId'
};

exports.Prisma.VideoScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isDeleted: 'isDeleted',
  uploadComplete: 'uploadComplete',
  videoDuration: 'videoDuration',
  videoUrl: 'videoUrl',
  workspaceId: 'workspaceId',
  muxAssetId: 'muxAssetId',
  muxPlaybackId: 'muxPlaybackId',
  fileType: 'fileType',
  contentType: 'contentType',
  uploaderId: 'uploaderId',
  recordingId: 'recordingId',
  transcriptStatus: 'transcriptStatus',
  transcriptError: 'transcriptError',
  transcriptId: 'transcriptId'
};

exports.Prisma.TranscriptUtteranceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isDeleted: 'isDeleted',
  videoId: 'videoId',
  contactId: 'contactId',
  startTime: 'startTime',
  endTime: 'endTime',
  speaker: 'speaker',
  text: 'text',
  workspaceId: 'workspaceId'
};

exports.Prisma.TagGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  color: 'color',
  name: 'name',
  workspaceId: 'workspaceId'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  color: 'color',
  icon: 'icon',
  name: 'name',
  summary: 'summary',
  summaryUpdated: 'summaryUpdated',
  tagGroupId: 'tagGroupId',
  workspaceId: 'workspaceId',
  kluGuid: 'kluGuid',
  productboardId: 'productboardId'
};

exports.Prisma.WidgetLinkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isDeleted: 'isDeleted',
  title: 'title',
  url: 'url',
  icon: 'icon',
  isEnabled: 'isEnabled',
  workspaceId: 'workspaceId'
};

exports.Prisma.WidgetSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isEnabled: 'isEnabled',
  workspaceId: 'workspaceId',
  widgetKey: 'widgetKey',
  hasCustomLinksEnabled: 'hasCustomLinksEnabled',
  customLinksHeading: 'customLinksHeading',
  isChangelogEnabled: 'isChangelogEnabled',
  isRoadmapEnabled: 'isRoadmapEnabled',
  isSupportEnabled: 'isSupportEnabled',
  isBrandingEnabled: 'isBrandingEnabled',
  hasCustomStylingEnabled: 'hasCustomStylingEnabled',
  isFeedbackEnabled: 'isFeedbackEnabled',
  isWhatsNewEnabled: 'isWhatsNewEnabled',
  isWidgetIconVisible: 'isWidgetIconVisible',
  defaultView: 'defaultView'
};

exports.Prisma.SidebarSectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  isDeleted: 'isDeleted',
  title: 'title',
  url: 'url',
  workspaceId: 'workspaceId'
};

exports.Prisma.SidebarSectionHeaderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  value: 'value',
  sidebarSectionId: 'sidebarSectionId'
};

exports.Prisma.HelpCenterGroupScalarFieldEnum = {
  id: 'id',
  name: 'name',
  order: 'order',
  workspaceId: 'workspaceId',
  version: 'version'
};

exports.Prisma.HelpCenterArticleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isDeleted: 'isDeleted',
  version: 'version',
  order: 'order',
  date: 'date',
  published: 'published',
  title: 'title',
  icon: 'icon',
  content: 'content',
  summary: 'summary',
  archived: 'archived',
  urlName: 'urlName',
  imageUrl: 'imageUrl',
  imageBlurhash: 'imageBlurhash',
  workspaceId: 'workspaceId',
  helpCenterGroupId: 'helpCenterGroupId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.MembershipRole = exports.$Enums.MembershipRole = {
  ADMIN: 'ADMIN',
  USER: 'USER',
  VIEWER: 'VIEWER'
};

exports.InviteState = exports.$Enums.InviteState = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED'
};

exports.TokenType = exports.$Enums.TokenType = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  API_ACCESS: 'API_ACCESS',
  EMAIL_LOGIN: 'EMAIL_LOGIN'
};

exports.UserRole = exports.$Enums.UserRole = {
  USER: 'USER',
  ADMIN: 'ADMIN'
};

exports.EmailType = exports.$Enums.EmailType = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND'
};

exports.IntercomHostRegions = exports.$Enums.IntercomHostRegions = {
  US: 'US',
  EU: 'EU',
  AU: 'AU'
};

exports.RoadmapSortOrder = exports.$Enums.RoadmapSortOrder = {
  LINEAR: 'LINEAR',
  LINEAR_REVERSE: 'LINEAR_REVERSE',
  SCORE_ASC: 'SCORE_ASC',
  SCORE_DESC: 'SCORE_DESC'
};

exports.SlackConnectSettingsType = exports.$Enums.SlackConnectSettingsType = {
  SINGLE: 'SINGLE',
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL'
};

exports.PainLevel = exports.$Enums.PainLevel = {
  UNKNOWN: 'UNKNOWN',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
};

exports.FeedbackState = exports.$Enums.FeedbackState = {
  NEW: 'NEW',
  PROCESSED: 'PROCESSED',
  COMPLETED: 'COMPLETED',
  SNOOZED: 'SNOOZED',
  UNSNOOZED: 'UNSNOOZED'
};

exports.FeedbackOrigin = exports.$Enums.FeedbackOrigin = {
  INAPP: 'INAPP',
  PORTAL: 'PORTAL',
  API: 'API',
  SLACK: 'SLACK',
  SLACK_CONNECT: 'SLACK_CONNECT',
  INTERCOM: 'INTERCOM',
  INTERCOM_ATTACHMENT: 'INTERCOM_ATTACHMENT',
  ZENDESK_ATTACHMENT: 'ZENDESK_ATTACHMENT',
  FRONT_ATTACHMENT: 'FRONT_ATTACHMENT',
  EMAIL: 'EMAIL',
  ZAPIER: 'ZAPIER',
  HUBSPOT: 'HUBSPOT',
  PLAIN: 'PLAIN',
  CALENDAR: 'CALENDAR',
  WIDGET: 'WIDGET'
};

exports.LinearDateResolution = exports.$Enums.LinearDateResolution = {
  month: 'month',
  quarter: 'quarter',
  halfYear: 'halfYear',
  year: 'year'
};

exports.SegmentType = exports.$Enums.SegmentType = {
  COMPANY: 'COMPANY',
  CONTACT: 'CONTACT'
};

exports.RecordingStatus = exports.$Enums.RecordingStatus = {
  SETTING_UP_BOT: 'SETTING_UP_BOT',
  IS_SCHEDULED: 'IS_SCHEDULED',
  PROCESSING: 'PROCESSING',
  JOINING_CALL: 'JOINING_CALL',
  LEAVING_CALL: 'LEAVING_CALL',
  IN_WAITING_ROOM: 'IN_WAITING_ROOM',
  RECORDING_PERMISSION_DENIED: 'RECORDING_PERMISSION_DENIED',
  IN_CALL_RECORDING: 'IN_CALL_RECORDING',
  DONE: 'DONE',
  FATAL: 'FATAL'
};

exports.TranscriptStatus = exports.$Enums.TranscriptStatus = {
  QUEUED: 'QUEUED',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR'
};

exports.WidgetView = exports.$Enums.WidgetView = {
  DEFAULT: 'DEFAULT',
  FEEDBACK: 'FEEDBACK',
  CHANGELOG: 'CHANGELOG'
};

exports.Prisma.ModelName = {
  ReplicacheClientGroup: 'ReplicacheClientGroup',
  ReplicacheClient: 'ReplicacheClient',
  NewReplicacheClient: 'NewReplicacheClient',
  PersonalSlackNotificationSettings: 'PersonalSlackNotificationSettings',
  Membership: 'Membership',
  WorkspaceInvite: 'WorkspaceInvite',
  Token: 'Token',
  User: 'User',
  EmailSettings: 'EmailSettings',
  ThreadMessage: 'ThreadMessage',
  Email: 'Email',
  Attachment: 'Attachment',
  SlackUser: 'SlackUser',
  SlackMessage: 'SlackMessage',
  Snippet: 'Snippet',
  Workspace: 'Workspace',
  AllowedEmailDomain: 'AllowedEmailDomain',
  IntercomSettings: 'IntercomSettings',
  HubspotSettings: 'HubspotSettings',
  PlainSettings: 'PlainSettings',
  RoadmapSettings: 'RoadmapSettings',
  CustomerPortalSettings: 'CustomerPortalSettings',
  SlackSettings: 'SlackSettings',
  SlackConnectSettings: 'SlackConnectSettings',
  SsoSettings: 'SsoSettings',
  Session: 'Session',
  Feedback: 'Feedback',
  CustomerNeed: 'CustomerNeed',
  FeedbackTemplate: 'FeedbackTemplate',
  Comment: 'Comment',
  Issue: 'Issue',
  Project: 'Project',
  LinearRoadmap: 'LinearRoadmap',
  Contact: 'Contact',
  Customer: 'Customer',
  Company: 'Company',
  CompanyMeta: 'CompanyMeta',
  Upvote: 'Upvote',
  IssueUpvote: 'IssueUpvote',
  Segment: 'Segment',
  Changelog: 'Changelog',
  MeetingRecording: 'MeetingRecording',
  Video: 'Video',
  TranscriptUtterance: 'TranscriptUtterance',
  TagGroup: 'TagGroup',
  Tag: 'Tag',
  WidgetLink: 'WidgetLink',
  WidgetSettings: 'WidgetSettings',
  SidebarSection: 'SidebarSection',
  SidebarSectionHeader: 'SidebarSectionHeader',
  HelpCenterGroup: 'HelpCenterGroup',
  HelpCenterArticle: 'HelpCenterArticle'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
